/*
  global AdobeAnalyticsRSID, SalesforceMobileLinksRedirect,
  FavoritesEnabled, ProfileEnabled,
  RefreshWhenNoAuth, NetworkConfig, FooterUpsellEnabled, gapi
*/
import React, { Component } from 'react';
import 'intersection-observer'; // IE11 polyfill
import 'helpers/uspapi';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import WindowResizeListener from 'react-window-size-listener';
import _ from 'lodash';
import { Events as scrollEvents, animateScroll } from 'react-scroll';
import { connect } from 'react-redux';
import StickyBanner from 'components/StickyBanner';
import { getFontHelmetTag, setHelmetTags } from 'helpers/HelmetHelper';
import getOpeFoxSdk from 'helpers/ScriptHelper';
import {
  MVPD_COOKIE_NAME as mvpdCookieName,
  findProvider,
  getProviderObjectFromList,
} from 'helpers/AuthHelper';
import {
  checkStatus as helperCheckStatus,
  deleteAccount,
  editAccount,
  editAccountIE,
  getAccount,
  getAccountCookie,
  getAnonymousAccountCookie,
  login as helperLogin,
  logoutClientless,
  logoutClientlessIE,
  register as helperRegister,
  registerIE,
  verify as helperVerify,
  noVerify as helperNoVerify,
  removeAccountCookie,
  reset as helperReset,
  resetIE,
  resetConfirm,
  setAccountCookie,
  toggleAccountExpired,
  removeAnonymousAccountCookie,
} from 'helpers/Account';
import { getAccessToken as helperGetAccessToken } from 'helpers/auth.clientless';
import {
  cookieFactory,
  getCookie,
  getDomain,
  getLocalStorageItem,
  getSessionStorageItem,
  removeCookie,
  removeLocalStorageItem,
  setCookie,
  setLocalStorageItem,
  setSessionStorageItem,
} from 'helpers/Storage';
import {
  clearLongTimeout,
  createProfile,
  getFontClassName,
  getMVPDFromCookie,
  getNetworkLogoUrl,
  getPrivacyParameterCookie,
  getPurchaseSourceCookie,
  getStickBannerData,
  getUrlParameter,
  isLive,
  isStaticRender,
  isTypeVideo,
  isUpcomingContent,
  sportsFeatures,
  v1Override,
} from 'helpers/ContentHelper';
import {
  appDownloadPromptEnabled,
  getBlackoutConfig,
  isEpgv2Enabled,
  isEpgLiveMiniPlayerEnabled,
  previewPassEnabled,
  setDebugFromUrl,
  setOptOutCCPACookie,
  tveEnabled,
  ccpaOptOutEnabled,
} from 'helpers/ConfigHelper';
import { PANEL_TYPE_LISTING } from 'screens/Live/LiveHelpers';
import { toBoolean, noop, isBrowserIE } from 'helpers/GlobalHelper';
import { PERK_ICON_IMAGE, renderImage } from 'helpers/ImageHelper';
import { isValidPage } from 'helpers/PageHelper';
import {
  getCampaignOverrides,
  getPreviousPathname,
  helperGetHomeUrl,
  isAppView,
  isAppViewExcluded,
  isGeoLocationBlocked,
  isMaintenance,
  redirectSalesForceLinksiOS,
  setSettingsPath,
} from 'helpers/RouteHelper';
import { isTestEnvironment } from 'helpers/TestHelper';
import {
  OVERLAY_BREAKPOINTS,
  OVERLAY_ACCOUNT,
  OVERLAY_HEADER_SEARCH,
  shouldPausePlayer,
} from 'helpers/FilterHelper';
import {
  DEBOUNCE_TIME,
  getSitePlatform,
  isMobileBreakpoint,
  isTabletBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
} from 'helpers/BreakpointHelper';
import {
  fetchAnonymousDataAfterLogout,
  getLatestAuthData,
  getStoredAuthenticatedMVPD,
  handleRefreshToken,
} from 'helpers/AuthClientlessHelper';
import { handleAnonymousLogin, parseJwt, resetAnonymous } from 'helpers/AnonymousHelper';
import {
  callTealiumPageView,
  getAccountAnalyticsEvents,
  PageNames,
  mountDataLayer,
  removeSegmentUserIdCookie,
  resetPageReferrerData,
  setBlockReferrerAnalyticsTracking,
  setSegmentLoaded,
  sortEntitlements,
  trackPageReferrerAnalytics,
  handleAnalytics,
  Events,
  SegmentPageProfileTypes,
} from '@foxcorp/delta-web-analytics';
import { logEvent } from 'helpers/LogReportHelpers';
import { getCachedLocation } from 'helpers/GeoLocationHelper';
import initializeRedfast from 'helpers/RedfastHelper';
import initializeDataDog from 'helpers/DataDogHelpers';

import {
  useMVPDLoginProfile as optimizelyUseMVPDLoginProfile,
  setInitOptimizelyAttributes,
  optimizelyLanguageStrings,
  getOptimizely,
  userAttributeEvents,
} from 'helpers/OptimizelyHelper';
import {
  addBodyClass,
  removeBodyClass,
  addHTMLClass,
  removeHTMLClass,
  getTheme,
  webThemeIds,
  wrapComponentsWithThemeProvider,
} from 'helpers/ThemeHelper';
import reset from 'themes/_reset.css'; // eslint-disable-line
import Account from 'components/Account';
import AuthContainer from 'components/AuthContainer';
import Header from 'components/Header';
import Footer from 'components/Footer';
import FooterUpsell from 'components/FooterUpsell';
import Loader from 'components/Loader';
import NetworkLink from 'components/NetworkLink';
import Segment from 'components/Segment';
import VideoPlayerGlobal from 'components/VideoPlayerGlobal';
import CanIAutoplay from 'components/CanIAutoplay';
import withErrorBoundary from 'components/withErrorBoundary';
import { getActivePlayer, isPreviewPass, playerPause, playerPlay } from 'helpers/PlayerHelper';

import {
  helperGetApiAccountRoute,
  helperGetApiHeaders,
  helperGetApiProfileIDRoute,
} from 'helpers/ApiHelper';
import {
  checkDeepLinkFavorite,
  getCommonTealiumProps,
  getFavoritesFromStorage,
  helperGetPerks,
  renderFavorites,
} from 'helpers/AccountHelper';
import BlackoutDefinitionFetcher from 'components/BlackoutDefinitionFetcher';
import { smartBannerPresent } from 'components/Header/HeaderHelpers';
import { makeSelectSeriesDetailSeriesData } from 'screens/SeriesDetail/selectors';
import {
  getTabName,
  PROMO_TYPE_INSET,
  PROMO_TYPE_LEAD,
  PROMO_TYPE_MARKETING_VIDEO,
} from 'screens/SeriesDetail/SeriesDetailHelpers';
import { makeSelectGlobalVideoPanelVideo } from 'screens/Watch/selectors';
import {
  fetchMVPDProvidersAction,
  setGoogleOneTap,
  setIsGoogleSignIn,
  setIsGoogleOneTapDisplayed,
  setNewGoogleEmailAndToken,
  setIsGoogleSignedInBrowser,
  setPreauthorizedResourcesAction,
  setRecommendationIdAction,
  setUserAuthData,
  setUserProfileConfig,
} from './AppActions';
import {
  getFavorites,
  getFavoritesIE,
  getFavoritesDetails,
  deleteFavorites,
  setFavorites,
  setAppFavorites,
} from './AppFavoritesHelpers';
import { fetchPCS } from '../components/Account/AccountComponents/ParentalControls/ParentalControlsActions';
import { GOOGLE_CLIENT_ID } from '../components/Account/AccountComponents/GoogleSignInButton/hooks/useGetGoogleSignIn';

import AppStyleModule from './App.module.scss';

import { injectGoogleSignIn } from '../external-scripts';

const style = getTheme(webThemeIds.App);

const breakpoints = {
  [SITE_PLATFORM_WEB_LARGE]: {
    autoFocus: true,
    mainBackground: null,
    breakpointDisableScroll: false,
  },
  [SITE_PLATFORM_WEB]: {
    autoFocus: true,
    mainBackground: null,
    breakpointDisableScroll: false,
  },
  [SITE_PLATFORM_TABLET]: {
    autoFocus: false,
    mainBackground: null,
    breakpointDisableScroll: true,
  },
  [SITE_PLATFORM_MOBILE]: {
    autoFocus: false,
    mainBackground: null,
    breakpointDisableScroll: true,
  },
};

const LAST_SESSION_PATH = 'lastFoxPath';
const APP_CLOSED = 'APP_CLOSED';

class App extends Component {
  constructor(props) {
    super(props);
    setSegmentLoaded();
    this.mapAnalytics();
    initializeDataDog();
    initializeRedfast();
    window.AdobeAnalyticsRSID = AdobeAnalyticsRSID;
    const { branding } = NetworkConfig;

    const breakpoint = SITE_PLATFORM_MOBILE;

    const locationCookies = getCachedLocation({ cb: this.locationCallback });

    this.appRef = React.createRef();

    this.state = {
      accountExpired: false,
      adblock: false,
      apiBreakpoint: null,
      authCheckComplete: false,
      authSuccess: false,
      blackoutDefinitions: null,
      blockReferrerAnalyticsTracking: false,
      blockSuccessScreen: false,
      breakpoint,
      campaignOverrides: getCampaignOverrides(),
      coordinates: locationCookies,
      currentPage: null,
      favorites: null,
      favoritesDetails: null,
      firstCollectionImpression: false,
      firstIdentifyCall: false,
      isHeader: null,
      isHeaderPinned: true,
      isHomePage: false,
      isListPage: false,
      isLivePage: false,
      isEpgLiveMiniPlayerEnabled: isEpgLiveMiniPlayerEnabled(),
      isNavScheduleRendered: false,
      isPageLoading: false,
      isPlayerLoaded: null,
      isSmartBannerEnabled: true,
      isVideoHero: null,
      isWatchPage: false,
      mvpdAuthOverlayProps: {},
      mvpdSignInTrigger: false,
      network: [branding],
      overlay: null,
      overlayPausedPlayer: null,
      preauthRefreshComplete: false,
      provider: null,
      renderMvpdAuthOverlay: false,
      renderLoader: false,
      showForgotPasswordLanding: false,
      showSignIn: false,
      showSignUp: false,
      triggerAuthCheck: false,
      upcomingOverlayOpen: false,
      useUtagGlobal: true,
      utagAccountSource: null,
    };

    this.handleRefreshToken = handleRefreshToken.bind(this);
    this.setBlockReferrerAnalyticsTracking = setBlockReferrerAnalyticsTracking.bind(this);
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.setMVPDSignInTrigger = newValue => {
      this.setState({
        mvpdSignInTrigger: newValue,
        renderMvpdAuthOverlay: newValue,
      });
    };
    this.setTriggerAuthCheck = newValue => {
      this.setState({
        triggerAuthCheck: newValue,
      });
    };
    this.openAccount = ({ cb, utagAccountSource, network = [branding] }) => {
      if (!ProfileEnabled) return;
      const { account: checkAccount } = this.props;
      this.setState({ utagAccountSource, network });
      this.setOverlay(OVERLAY_ACCOUNT, true, () => {
        if (cb) cb();
        if (checkAccount) {
          this.pageViewEvent({ pageName: PageNames.SETTINGS });
          handleAnalytics({
            event: Events.SETTINGS_SECTION_LANDING,
            payload: {
              pageName: `settings:landing`,
              pageType: 'settings:section-front',
            },
          });
        }
      });
    };
    this.openSignIn = ({ utagAccountSource }) => {
      if (!ProfileEnabled) return;
      this.setState({ showSignIn: true });
      this.openAccount({ utagAccountSource });
    };
    this.openSignUp = ({ utagAccountSource }) => {
      if (!ProfileEnabled) return;
      this.setState({ showSignUp: true });
      this.openAccount({ utagAccountSource });
    };
    this.openForgotPassword = (network = [branding], selectedNetwork = null) => {
      this.setState({ showForgotPasswordLanding: true, selectedNetwork });
      this.openAccount({ network });
    };
    this.onAuthCheckComplete = ({ complete, success, cb }) => {
      const nextState = {};
      if (complete !== undefined) nextState.authCheckComplete = complete;
      if (success !== undefined) nextState.authSuccess = success;
      const callback = cb || _.noop;
      this.setState(nextState, callback);
    };
    this.resetAnonymous = resetAnonymous.bind(this);
    this.onBlackoutDefinitionFetcherUpdate = blackoutDefinitions =>
      // TODO: we might be able to use redux for this state.blackoutDefinitionFetcher.definition
      this.setState({
        blackoutDefinitions,
      });
    this.firstSegmentIdentifyCalled = () => this.setState({ firstIdentifyCall: true });
    this.collectionImpressionCalled = () => this.setState({ firstCollectionImpression: true });
    this.upcomingOverlayOpen = state => {
      if (!state) {
        this.disableScrollByClass({ disableScroll: false, bodyOnly: true });
      } else {
        this.disableScrollByClass({ disableScroll: true, bodyOnly: true });
      }
      this.setState({ upcomingOverlayOpen: state });
    };
    this.checkDeepLinkFavorite = checkDeepLinkFavorite.bind(this);

    window.PreviewPassEnabled = previewPassEnabled();
    window.RefreshWhenNoAuth = RefreshWhenNoAuth;

    if (FavoritesEnabled) {
      this.setAppFavorites = setAppFavorites.bind(this);
      this.getFavorites = isBrowserIE() ? getFavoritesIE.bind(this) : getFavorites.bind(this);
      this.getFavoritesDetails = getFavoritesDetails.bind(this);
      this.setFavorites = setFavorites.bind(this);
      this.deleteFavorites = deleteFavorites.bind(this);
    } else {
      this.setAppFavorites = () => {};
      this.getFavorites = () => {};
      this.getFavoritesDetails = () => {};
      this.setFavorites = () => {};
      this.deleteFavorites = () => {};
    }
  }

  async componentDidMount() {
    const { breakpoint } = this.state;
    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken: accessToken,
      isAuthenticated,
      fetchPCS,
      setUserProfileConfig,
    } = this.props;
    const profileId = account?.profileId || anonymousAccount?.profileId;
    setOptOutCCPACookie();
    this.handleXid();
    const script = document.createElement('script');
    if (getPrivacyParameterCookie()) {
      script.innerHTML = getOpeFoxSdk({ profileId, anonymousId });
    }
    document.head.appendChild(script);

    setUserProfileConfig({ accessToken, profileId });
    logEvent('onAppLoad');
    window.onstorage = e => {
      if (e.key === APP_CLOSED) {
        removeLocalStorageItem({ key: APP_CLOSED });
      }
    };

    resetPageReferrerData();
    this.trackPageReferrerAnalytics({ name: PageNames.DEEPLINK });
    setSessionStorageItem({ key: LAST_SESSION_PATH, value: '' });
    if (SalesforceMobileLinksRedirect) redirectSalesForceLinksiOS();
    setInitOptimizelyAttributes(isAuthenticated, account);
    if (!smartBannerPresent(breakpoint)) {
      this.setSmartBannerEnabled(false);
    }
    if (isBrowserIE()) {
      this.getFavorites();
    }
    const hash = _.get(this.props, 'location.hash');
    if (hash) setDebugFromUrl(hash);

    const currentAccount = account || anonymousAccount;
    this.handleRefreshToken(currentAccount);
    if (account) fetchPCS(currentAccount.accessToken);

    this.setState({ renderLoader: false });
    this.loadGoogleSignInAPI();
    if (!account) this.loadGoogleOneTap();
    // loadExternalLibs();
  }

  // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { favoriteDetails, favorites } = this.state;
    const nextPathName = _.get(nextProps, 'location.pathname');
    const isAccountPage = /^\/(tv\/)*account((\/\w+)+|\/?)$/.test(nextPathName);
    if (isAccountPage && (!favorites || (favorites && !favoriteDetails))) {
      this.getFavoritesDetails();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const hash = _.get(this.props, 'location.hash');
    const prevHash = _.get(prevProps, 'location.hash');
    const { loggingOut, overlay } = this.state;
    const { overlay: prevOverlay } = prevState;
    const {
      account,
      anonymousAccount,
      deviceId,
      fetchPCS,
      mvpd,
      mvpdLogoutData,
      profileConfig,
      setUserAuthData,
      stickyBanner,
      location,
      setUserProfileConfig,
    } = this.props;
    const {
      account: prevAccount,
      anonymousAccount: prevAnonymousAccount,
      mvpd: prevMvpd,
      mvpdLogoutData: prevMvpdLogoutData,
      profileConfig: prevProfileConfig,
      stickyBanner: prevStickyBanner,
      location: prevLocation,
    } = prevProps;

    const currentPath = location?.pathname;
    const prevPath = prevLocation?.pathname;
    if (currentPath !== prevPath) {
      userAttributeEvents().currentPageUrl();
    }

    const accountAccessToken = helperGetAccessToken(account);
    const accountAdded = !prevAccount && account;
    const accountChanged = account && account !== prevAccount;
    const anonymousAccessToken = helperGetAccessToken(anonymousAccount);
    const anonymousAccountAdded = !prevAnonymousAccount && anonymousAccount;
    const anonymousAccountChanged = anonymousAccount && anonymousAccount !== prevAnonymousAccount;
    const isAnonymousAccountLogin = anonymousAccountChanged && !anonymousAccount.isNew;
    const isSearchOverlay = overlay === OVERLAY_HEADER_SEARCH;
    const mvpdAdded = !prevMvpd && mvpd;
    const mvpdLogoutAdded = !prevMvpdLogoutData && mvpdLogoutData;
    const newTokenAvailable = mvpdAdded || anonymousAccountAdded || accountAdded || mvpdLogoutAdded;
    const overlayChanged = prevOverlay !== overlay;
    const prevAccountAccessToken = helperGetAccessToken(prevAccount);
    const prevAnonymousAccessToken = helperGetAccessToken(prevAnonymousAccount);

    const accountTokenChanged = !!(
      prevAccountAccessToken &&
      accountAccessToken &&
      accountAccessToken !== prevAccountAccessToken
    );
    const anonTokenChanged = !!(
      prevAnonymousAccessToken &&
      anonymousAccessToken &&
      anonymousAccessToken !== prevAnonymousAccessToken
    );

    if (overlayChanged) this.setBlockReferrerAnalyticsTracking(isSearchOverlay || false);
    if (accountTokenChanged) this.handleRefreshToken(account);
    if (anonTokenChanged) this.handleRefreshToken(anonymousAccount);
    if (accountAdded) {
      setUserAuthData({ anonymousAccount: null });
      fetchPCS(account.accessToken);
    }

    if (newTokenAvailable && !loggingOut) {
      let authData;

      try {
        const { latestStoredData } = await getLatestAuthData({
          anonymousLogin: this.anonymousLogin,
          currentDeviceId: deviceId,
        });
        authData = latestStoredData;
        const { accessToken, profileId } = authData;
        setUserProfileConfig({ accessToken, profileId });
      } catch (e) {
        console.error('fetching latest auth data failed');
      }

      const accessToken = helperGetAccessToken(authData);

      setUserAuthData({ authorizationToken: accessToken });
    }

    if (accountChanged || isAnonymousAccountLogin) this.getFavorites();

    const hashChanged = hash && hash !== prevHash;
    if (hashChanged) setDebugFromUrl(hash);

    if (!prevStickyBanner && stickyBanner) {
      this.setState({ stickyBanner });
    }

    if (!prevProfileConfig && profileConfig) this.getFavorites();
  }

  componentWillUnmount() {
    const { refreshTokenTimeout } = this.state;
    if (refreshTokenTimeout) {
      clearLongTimeout(refreshTokenTimeout);
    }
    window.removeEventListener('unload', () => {});
  }

  handleXid = async () => {
    const { account, anonymousAccount } = this.props;
    const profileId = account?.profileId || anonymousAccount?.profileId;
    const { profile } = await createProfile(account?.accessToken, profileId);
    browserHistory.listen(() => {
      profile.getXid({ baseUrl: window.location?.origin }).then(xidResponse => {
        const xid = xidResponse?.xid;
        profile.submitXidEvent({ eventType: 'view', originBu: 'foxnow', xid });
      });
    });
    let xidResponse;
    try {
      xidResponse = await profile.getXid({ baseUrl: window.location?.origin });
    } catch (error) {
      console.log('getXid Request failed', error);
    }
    profile.submitXidEvent({ eventType: 'view', originBu: 'foxnow', xid: xidResponse?.xid });
    const Fennec = window.Fennec || null;
    if (Fennec) {
      window.fennecInstance = new Fennec('now');
      window.fennecInstance?.initFennec();
    }
  };

  // handleSetGoogleAccountData function executes after successful Google One Tap login
  handleSetGoogleAccountData(res) {
    removeAnonymousAccountCookie();
    setAccountCookie(res);
    this.closeAccount();
    this.resetAccountState();
    this.setAccountCloseIgnoreRedirect(false);
    setGoogleOneTap({ isGoogleOneTap: false });
    handleAnalytics({
      event: Events.PROFILE_SIGNIN_COMPLETED,
      payload: {
        page_profile_type: SegmentPageProfileTypes.GOOGLE,
        page_start_source: this.state.utagAccountSource ?? 'general',
      },
      tealiumPayload: {
        ...getCommonTealiumProps(),
      },
    });
  }

  async handleGoogleLink({ email, googleToken }) {
    try {
      const { profile } = this.props;
      const res = await profile.googleLink({
        additionalHeaders: v1Override,
        email,
        googleToken,
      });
      this.handleSetGoogleAccountData(res);
    } catch (e) {
      console.log(e);
    }
  }

  loadGoogleOneTap() {
    const handleGoogleOneTap = async (googleEmail, credential) => {
      const { account, setGoogleOneTap, profile } = this.props;
      let isFound;
      try {
        const statusResponse = await profile?.status({ email: googleEmail });
        const { found } = statusResponse;
        isFound = found;
        const loginResponse = await profile?.googleLogin({ googleToken: credential });
        const isUserTypeGoogle = loginResponse?.userType === 'google';
        if (!account && isFound && isUserTypeGoogle) {
          this.handleSetGoogleAccountData(loginResponse);
        }
      } catch (e) {
        setGoogleOneTap({
          googleOneTapEmail: googleEmail,
          googleToken: credential,
          isGoogleOneTap: true,
        });
        this.handleGoogleLink({ email: googleEmail, googleToken: credential });
      }
    };
    const options = {
      client_id: GOOGLE_CLIENT_ID,
      auto_select: false,
      cancel_on_tap_outside: false,
      context: 'signin',
    };

    this.googleOneTap(options, response => {
      const { credential } = response;
      const user = parseJwt(credential);
      handleGoogleOneTap(user?.email, credential);
    });
  }

  googleOneTap = async (
    { client_id, auto_select = false, cancel_on_tap_outside = false, context = 'signin' },
    callback,
  ) => {
    // load the one tap sdk here sdk
    await injectGoogleSignIn();
    const { setIsGoogleOneTapDisplayed } = this.props;
    const contextValue = ['signin', 'signup', 'use'].includes(context) ? context : 'signin';
    if (client_id) {
      window?.google?.accounts?.id?.initialize({
        client_id,
        callback,
        auto_select,
        cancel_on_tap_outside,
        context: contextValue,
      });
      window?.google?.accounts?.id?.prompt(notification => {
        const isDisplayed = notification.isDisplayed();
        setIsGoogleOneTapDisplayed(isDisplayed);
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          setIsGoogleOneTapDisplayed(isDisplayed);
        }
      });
    } else {
      console.error('client_id is missing');
    }
  };

  loadGoogleSignInAPI = () => {
    const { setIsGoogleSignedInBrowser } = this.props;
    // eslint-disable-next-line no-undef
    const googleAPI = window.gapi ? gapi : null;
    let auth2;
    let googleUser;

    const initSigninV2 = () => {
      auth2 = gapi.auth2.init({
        client_id: GOOGLE_CLIENT_ID,
        cookiepolicy: 'single_host_origin',
        scope: 'profile',
      });
      const updateGoogleUser = () => {
        const isSignedIn = googleUser?.isSignedIn();
        const googleEmail = googleUser?.getBasicProfile()?.getEmail();
        const googleToken = googleUser?.getAuthResponse()?.id_token;
        if (isSignedIn) {
          setIsGoogleSignedInBrowser({ googleEmail, googleToken, isSignedIn });
        }
      };

      const signinChanged = val => {
        console.log('Signin state changed to ', val);
      };

      const userChanged = user => {
        googleUser = user;
        updateGoogleUser();
      };

      const refreshValues = () => {
        if (auth2) {
          googleUser = auth2.currentUser.get();
          updateGoogleUser();
        }
      };

      auth2.isSignedIn.listen(signinChanged);
      auth2.currentUser.listen(userChanged);
      refreshValues();
    };

    if (googleAPI) {
      googleAPI.load('auth2', initSigninV2);
    }
  };

  mapAnalytics = () => {
    window.DataLayer = mountDataLayer({
      cookieFactory,
      enums: {
        MVPD_COOKIE: mvpdCookieName,
        PANEL_TYPE_LISTING,
        PROMO_TYPE_INSET,
        PROMO_TYPE_LEAD,
        PROMO_TYPE_MARKETING_VIDEO,
      },
      getAccount: getAccountCookie,
      getAnonymousAccount: getAnonymousAccountCookie,
      getCookie,
      getDetailTabName: getTabName,
      getFavorites: getFavoritesFromStorage,
      getLocalStorage: getLocalStorageItem,
      getMVPD: getMVPDFromCookie,
      getOptimizely,
      getPurchaseSource: getPurchaseSourceCookie,
      getQueryParameter: getUrlParameter,
      getSessionStorage: getSessionStorageItem,
      getSportsFeatures: sportsFeatures,
      isContentLive: isLive,
      isNation: () => false,
      isNationNewsEnabled: () => false,
      isPreviewPass,
      isTestEnvironment,
      isTveEnabled: tveEnabled,
      isUpcomingContent,
      isVideoTile: isTypeVideo,
      removeCookie,
      setCookie,
      setLocalStorage: setLocalStorageItem,
      setSessionStorage: setSessionStorageItem,
      ccpaOptOutEnabled,
    });
  };

  onSignUpSuccess = () => {
    this.setState({ showSignUp: false });
    this.resetAnonymous({ copyFavoritesToAccount: true });
    this.checkDeepLinkFavorite();
  };

  onWindowResize = _.debounce(() => {
    const windowWidth = _.get(window, 'innerWidth');
    const newBreakpoint = getSitePlatform(windowWidth);

    if (newBreakpoint === SITE_PLATFORM_MOBILE) return;

    const {
      breakpoint: currentBreakpoint,
      apiBreakpoint: currentApiBreakpoint,
      overlay,
      useSimplified,
    } = this.state;

    const newApiBreakpoint = !isStaticRender() ? newBreakpoint : currentApiBreakpoint;
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const newState = {};
    if (newBreakpoint !== currentBreakpoint) {
      newState.breakpoint = newBreakpoint;
      let disableScroll = false;
      if (overlay) {
        disableScroll = OVERLAY_BREAKPOINTS[newBreakpoint].indexOf(overlay) >= 0;
      }
      if (useSimplified) {
        disableScroll = true;
      }
      this.setDisableScroll({ disableScroll });
    }
    if (newApiBreakpoint !== currentApiBreakpoint) {
      newState.apiBreakpoint = newBreakpoint;
    }
    if (newState.breakpoint || newState.apiBreakpoint) {
      this.setState(newState);
    }
  }, DEBOUNCE_TIME);

  getCurrentPage = () => {
    const { currentPage } = this.state;
    return currentPage;
  };

  getExternalHelpers() {
    const {
      authCheckComplete,
      authSuccess,
      blockReferrerAnalyticsTracking,
      favorites,
      favoritesDetails,
      renderMvpdAuthOverlay,
    } = this.state;

    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken: accessToken,
      deviceId,
      mvpd,
      preauthorizedResources,
      profile,
      recommendationId,
      routes,
      segmentDeviceId,
    } = this.props;
    const profileId = _.get(account, 'profileId') || _.get(anonymousAccount, 'profileId');
    const appView = isAppView(routes);
    const geoLocationBlocked = isGeoLocationBlocked(routes);
    const maintenance = isMaintenance(routes);
    let headers = helperGetApiHeaders({ accessToken, deviceId });

    const logout = async () => {
      this.setState({ loggingOut: true });
      removeAccountCookie();
      removeSegmentUserIdCookie();

      const route = helperGetApiAccountRoute('logout');

      if (headers && route && logoutClientless) {
        if (isBrowserIE()) {
          await logoutClientlessIE({ ...headers, route }).catch(e => {
            console.error(e);
          });
        } else {
          await logoutClientless({ profile }).catch(e => {
            console.error(e);
          });
        }

        const newAccessToken = await fetchAnonymousDataAfterLogout({
          anonymousLogin: this.anonymousLogin,
          deviceId,
          setMVPDToAppState: this.setMVPDToAppState,
        });
        this.setAuthorizationToken(newAccessToken);
      }
    };
    const login = helperLogin.bind(
      this,
      {
        route: helperGetApiAccountRoute('login'),
        headers,
      },
      profile,
    );
    const checkStatus = helperCheckStatus.bind(this.setState, profile);
    const register = isBrowserIE()
      ? registerIE.bind(this, {
          route: helperGetApiAccountRoute('emailRegister'),
          headers,
        })
      : helperRegister.bind(this, {
          profile,
        });
    const verifyAccount = helperVerify.bind(this, {
      route: helperGetApiAccountRoute('verify'),
      headers,
    });
    const noVerifyAccount = helperNoVerify.bind(this, {
      route: helperGetApiAccountRoute('noVerify'),
      headers,
    });
    const standardHelpers = {
      authCheckComplete,
      authSuccess,
      setProvider: this.setProvider,
      toggleAccountExpired: toggleAccountExpired.bind(this),
      socialFacebookRegister: register,
      socialFacebookLogin: login,
      register,
      login,
      logout,
      checkStatus,
      reset: isBrowserIE()
        ? resetIE.bind(this, {
            route: helperGetApiAccountRoute('reset'),
            headers,
          })
        : helperReset.bind(this, {
            profile,
          }),
      resetConfirm: resetConfirm.bind(this, {
        route: helperGetApiAccountRoute('resetConfirm'),
        headers,
      }),
      favoritesManager: {
        favorites: favorites || [],
        favoritesDetails: favoritesDetails || [],
        setFavorites: this.setFavorites,
        deleteFavorites: this.deleteFavorites,
      },
      openAccount: this.openAccount,
      resetAccountState: this.resetAccountState.bind(this),
      closeAccount: this.closeAccount,
      setOverlay: this.setOverlay,
      setAccountCloseIgnoreRedirect: this.setAccountCloseIgnoreRedirect,
      setVideoHero: () => {
        this.setState({ isVideoHero: true });
      },
      removeVideoHero: () => {
        this.setState({ isVideoHero: false });
      },
      onAuthCheckComplete: this.onAuthCheckComplete,
      openSignIn: this.openSignIn,
      openSignUp: this.openSignUp,
      openForgotPassword: this.openForgotPassword,
      renderAuthContainer: this.renderAuthContainer,
      renderMvpdAuthOverlay,
      setBlockMVPDIncomplete: this.setBlockMVPDIncomplete,
      setCoordinates: this.setCoordinates,
      setAuthorizationToken: this.setAuthorizationToken,
      setCurrentPage: this.setCurrentPage,
      getCurrentPage: this.getCurrentPage,
      setWatchPage: this.setWatchPage,
      setLivePage: this.setLivePage,
      setListPage: this.setListPage,
      setHomePage: this.setHomePage,
      setLoading: this.setLoading,
      setIsPlayerLoaded: this.setIsPlayerLoaded,
      setMVPDLogoutDataToAppState: this.setMVPDLogoutDataToAppState,
      setMVPDToAppState: this.setMVPDToAppState,
      setTriggerAuthCheck: this.setTriggerAuthCheck,
      toggleMvpdAuthOverlay: this.toggleMvpdAuthOverlay,
      pageViewEvent: this.pageViewEvent,
      setIsAuthenticated: this.setIsAuthenticated,
      appView,
      isAppViewExcluded,
      geoLocationBlocked,
      maintenance,
      getUseUtagGlobal: () => {
        const { useUtagGlobal } = this.state;
        if (useUtagGlobal) this.setState({ useUtagGlobal: false });
        return useUtagGlobal;
      },
      blockReferrerAnalyticsTracking,
      anonymousId,
      anonymousAccount,
      preauthorizedResources,
      accessToken,
      profileId,
      anonymousLogin: this.anonymousLogin,
      recommendationId,
      deviceId,
      mvpdData: mvpd,
      segmentDeviceId,
      verifyAccount,
      noVerifyAccount,
    };

    if (account && accessToken && profileId) {
      headers = helperGetApiHeaders({ accessToken, deviceId });
      const accountReq = {
        route: helperGetApiProfileIDRoute({ pathKey: 'account', profileId }),
        headers,
      };
      const previousPath = getPreviousPathname();

      return {
        ...standardHelpers,
        openAccount: this.openAccount,
        deleteAccount: deleteAccount.bind(this, accountReq),
        editAccount: isBrowserIE()
          ? editAccountIE.bind(this, accountReq)
          : editAccount.bind(this, { profile }),
        getAccount: getAccount.bind(this, accountReq),
        previousPath,
      };
    }
    return standardHelpers;
  }

  locationCallback = (error, coordinates) => {
    if (error) this.setCoordinates(null);
    if (coordinates) this.setCoordinates(coordinates);
  };

  setAccountCloseIgnoreRedirect = v => {
    this.setState({ accountCloseIgnoreRedirect: v });
  };

  setAuthorizationToken = authorizationToken => {
    const { authorizationToken: currentAuthorizationToken, setUserAuthData } = this.props;
    if (currentAuthorizationToken === authorizationToken) return;
    setUserAuthData({ authorizationToken });
  };

  setBlockMVPDIncomplete = v => this.setState({ blockMVPDIncomplete: v });

  setCoordinates = coordinates => {
    this.setState({ coordinates });
  };

  setCurrentPage = newCurrentPage => {
    const { currentPage } = this.state;
    if (currentPage === newCurrentPage) return;
    if (!isValidPage(newCurrentPage)) return;
    this.setState({ currentPage: newCurrentPage });
  };

  setDisableScroll({ disableScroll, overlay, cb }) {
    const { breakpoint } = this.state;
    const { breakpointDisableScroll } = breakpoints[breakpoint];
    if (disableScroll && breakpointDisableScroll) {
      scrollEvents.scrollEvent.register('end', () => {
        this.disableScrollByClass({ disableScroll, overlay, cb, breakpointDisableScroll });
        scrollEvents.scrollEvent.remove('end');
      });
      animateScroll.scrollTo(-1, { duration: 125, smooth: true });
    } else {
      this.disableScrollByClass({ disableScroll, overlay, cb, breakpointDisableScroll });
    }
  }

  setHeaderPin = value => {
    const { isHeaderPinned } = this.state;
    if (isHeaderPinned !== value) {
      this.setState({ isHeaderPinned: value });
    }
  };

  setHomePage = newIsHomePage => {
    const { isHomePage } = this.state;
    if (isHomePage === newIsHomePage) return;
    this.setState({ isHomePage: newIsHomePage });
  };

  setIsAuthenticated = value => {
    const { setUserAuthData } = this.props;
    setUserAuthData({ isAuthenticated: value });
  };

  setIsPlayerLoaded = newIsPlayerLoaded => {
    const { isPlayerLoaded, isWatchPage } = this.state;
    if (isPlayerLoaded === newIsPlayerLoaded) return;
    const newState = { isPlayerLoaded: newIsPlayerLoaded };
    if (newIsPlayerLoaded && isWatchPage) {
      newState.vodPlayerWasLoaded = true;
    }
    this.setState(newState);
  };

  setListPage = newIsListPage => {
    const { isListPage } = this.state;
    if (isListPage === newIsListPage) return;
    this.setState({ isListPage: newIsListPage });
  };

  setLivePage = newIsLivePage => {
    const { isLivePage } = this.state;
    if (isLivePage === newIsLivePage) return;
    this.setState({ isLivePage: newIsLivePage });
  };

  setLoading = newIsPageLoading => {
    this.setState({ isPageLoading: newIsPageLoading });
  };

  setMVPDLogoutDataToAppState = mvpdLogoutData => {
    const { setUserAuthData } = this.props;
    setUserAuthData({ mvpdLogoutData });
  };

  setMVPDToAppState = mvpd => {
    const { setUserAuthData } = this.props;
    setUserAuthData({ mvpd });
  };

  setNavScheduleRendered = newIsNavScheduleRendered => {
    const { isNavScheduleRendered } = this.state;
    if (isNavScheduleRendered === newIsNavScheduleRendered) return;
    this.setState({ isNavScheduleRendered: newIsNavScheduleRendered });
  };

  setOverlay = (chosenOverlay, chosenValue, cb) => {
    const { breakpoint, overlay } = this.state;
    let toggleValue = chosenValue;
    let disableScroll = false;
    let sentOverlay = chosenOverlay;
    if (!_.isBoolean(toggleValue)) {
      toggleValue = chosenOverlay !== overlay;
    }
    if (chosenOverlay && chosenOverlay !== overlay && chosenValue === false) return;
    if (toggleValue) {
      disableScroll = OVERLAY_BREAKPOINTS[breakpoint].indexOf(chosenOverlay) >= 0;
    } else if (overlay === chosenOverlay) {
      sentOverlay = null;
    } else if (!chosenOverlay && !chosenValue) {
      sentOverlay = null;
    }
    this.setDisableScroll({ disableScroll, overlay: sentOverlay, cb });
  };

  setProvider = provider => {
    const { account, mvpdProviders } = this.props;
    const findProviderAndSet = (providerId, providers) => {
      const providerObject = findProvider(providers, account, providerId);
      return this.setState({ provider: providerObject });
    };

    const providerFetched = getProviderObjectFromList(mvpdProviders, provider);
    if (!mvpdProviders || !providerFetched) {
      const checkForProviders = setInterval(() => {
        const { mvpdProviders: newProviders } = this.props;
        if (!newProviders) return null;
        clearInterval(checkForProviders);
        return findProviderAndSet(provider, newProviders);
      }, 1000);
    } else {
      findProviderAndSet(provider, mvpdProviders);
    }
    return null;
  };

  setPreauthRefreshComplete = value => {
    this.setState({ preauthRefreshComplete: value });
  };

  setSmartBannerEnabled = isSmartBannerEnabled => {
    const { state } = this;
    if (state.isSmartBannerEnabled === isSmartBannerEnabled) return;
    this.setState({ isSmartBannerEnabled });
  };

  setWatchPage = newIsWatchPage => {
    const { isWatchPage } = this.state;
    if (isWatchPage === newIsWatchPage) return;
    this.setState({ isWatchPage: newIsWatchPage });
  };

  anonymousLogin = ({ deviceId }) => {
    const { authorizationToken, deviceId: currentDeviceId, setUserAuthData, profile } = this.props;
    return handleAnonymousLogin({
      authorizationToken,
      deviceId: deviceId || currentDeviceId,
      setUserAuthData,
      profile,
    });
  };

  closeAccount = ({ goHome, ignoreRedirect, savedPath } = {}) => {
    const account = getAccountCookie();
    const { setUserAuthData } = this.props;
    setUserAuthData({ account });
    this.setOverlay(OVERLAY_ACCOUNT, false);
    if (ignoreRedirect) return;

    const homePath = helperGetHomeUrl();
    const previousPath = getPreviousPathname();
    let nextPath = goHome ? homePath : previousPath || homePath;
    nextPath = savedPath || nextPath;
    if (savedPath) setSettingsPath('');
    browserHistory.push(nextPath);
  };

  pageViewEvent = (opts = {}) => {
    const {
      collection,
      footerType,
      pageName,
      pageTitle,
      pageType,
      panelExperimentData,
      selectedMenuItem,
      seriesType,
      useUtagGlobal,
      cb,
    } = opts;
    const { favorites, provider } = this.state;
    const { account, preauthorizedResources: networkEntitlementList } = this.props;
    const pageViewEvents = async () => {
      if (!isStaticRender())
        await callTealiumPageView({
          account,
          collection,
          domain: getDomain(),
          favorites,
          footerType,
          networkEntitlementList,
          pageName,
          pageTitle,
          pageType,
          panelExperimentData,
          provider,
          selectedMenuItem,
          seriesType,
          useUtagGlobal,
          cb,
        });
    };
    pageViewEvents();
  };

  showAccount = () => {
    const { overlay } = this.state;
    return overlay === OVERLAY_ACCOUNT;
  };

  toggleMvpdAuthOverlay = (value = true, options = {}, blockSuccessScreen = true) => {
    this.setState({
      mvpdAuthOverlayProps: options,
      renderMvpdAuthOverlay: value,
      blockSuccessScreen,
    });
  };

  disableScrollByClass({
    disableScroll,
    overlay,
    cb,
    breakpointDisableScroll,
    bodyOnly,
    fixedPosition,
  }) {
    if (disableScroll) {
      addBodyClass(['noScroll', 'bodyNoScroll']);
      if (!bodyOnly) addHTMLClass(['noScroll']);
      if (fixedPosition) addHTMLClass(['fixedPosition']);
    } else {
      removeBodyClass(['noScroll', 'bodyNoScroll']);
      if (!bodyOnly) removeHTMLClass(['noScroll']);
      if (!fixedPosition) removeHTMLClass(['fixedPosition']);
    }

    if (!_.isUndefined(overlay)) {
      const { overlayPausedPlayer } = this.state;
      const newState = { overlay };
      const pausePlayer = shouldPausePlayer({ overlay, breakpointDisableScroll });
      const hasPlayer = !_.isEmpty(window.player);
      const shouldTogglePlayer = hasPlayer && pausePlayer;

      if (shouldTogglePlayer) {
        const activePlayer = getActivePlayer();
        if (overlay && activePlayer) {
          newState.overlayPausedPlayer = activePlayer;
          playerPause(activePlayer);
        } else if (!overlay && overlayPausedPlayer) {
          newState.overlayPausedPlayer = null;
          playerPlay(overlayPausedPlayer);
        }
      }
      this.setState(newState, () => {
        if (_.isFunction(cb)) cb();
      });
    }
  }

  resetAccountState() {
    this.setState({
      showForgotPasswordLanding: false,
      showSignIn: false,
      showSignUp: false,
    });
  }

  renderAuthContainer = additionalAuthProps => {
    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken,
      deviceId,
      preauthorizedResources,
    } = this.props;
    const {
      blackoutDefinitions,
      blockMVPDIncomplete,
      blockSuccessScreen,
      breakpoint,
      provider,
      mvpdSignInTrigger,
    } = this.state;

    const useMVPDLoginProfile = !getStoredAuthenticatedMVPD() && optimizelyUseMVPDLoginProfile();

    const authProps = {
      account,
      accessToken: authorizationToken,
      anonymousAccount,
      anonymousId,
      anonymousLogin: this.anonymousLogin,
      blackoutConfig: getBlackoutConfig(),
      blackoutDefinitions,
      blockMVPDIncomplete,
      blockSuccessScreen,
      closeAccount: this.closeAccount.bind(this),
      'data-test': 'auth-container',
      deviceId,
      isMobile: isMobileBreakpoint(breakpoint),
      isTablet: isTabletBreakpoint(breakpoint),
      mvpdLoginProfile: useMVPDLoginProfile,
      onAuthCheckComplete: this.onAuthCheckComplete,
      openSignIn: this.openSignIn,
      openSignUp: this.openSignUp,
      preauthorizedResources,
      pageViewEvent: this.pageViewEvent,
      profileToken: authorizationToken,
      provider,
      mvpdSignInTrigger,
      requiresAuth: true,
      setAccountCloseIgnoreRedirect: this.setAccountCloseIgnoreRedirect,
      setAuthorizationToken: this.setAuthorizationToken,
      setIsAuthenticated: this.setIsAuthenticated,
      setMVPDSignInTrigger: this.setMVPDSignInTrigger,
      setMVPDToAppState: this.setMVPDToAppState,
      setMVPDLogoutDataToAppState: this.setMVPDLogoutDataToAppState,
      setOverlay: this.setOverlay,
      setProvider: this.setProvider,
      ...additionalAuthProps,
    };
    return <AuthContainer {...authProps} />;
  };

  renderDefaultHelmetTags = () => {
    const { headerTags } = NetworkConfig;
    const data = {
      ...headerTags,
      viewport: 'width=device-width, initial-scale=1',
      ogType: 'website',
      tags: [
        <meta key="content-type" httpEquiv="Content-Type" content="text/html; charset=UTF-8" />,
      ],
    };
    return setHelmetTags(data);
  };

  renderGlobalVideoPlayer() {
    const {
      adblock,
      authCheckComplete,
      authSuccess,
      blackoutDefinitions,
      breakpoint,
      coordinates,
      isEpgLiveMiniPlayerEnabled,
      isHomePage,
      isLivePage,
      isPlayerLoaded,
      openSignIn,
      openSignUp,
      provider,
      triggerAuthCheck,
    } = this.state;
    const {
      account,
      anonymousId,
      anonymousAccount,
      authorizationToken,
      deviceId,
      location,
      params,
    } = this.props;

    const profileId = _.get(account, 'profileId') || _.get(anonymousAccount, 'profileId');
    const props = {
      ...this.getExternalHelpers(),
      accessToken: authorizationToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin: this.anonymousLogin,
      appRef: this.appRef,
      authCheckComplete,
      authSuccess,
      blackoutConfig: getBlackoutConfig(),
      blackoutDefinitions,
      breakpoint,
      coordinates,
      'data-test': 'home-video-global',
      deviceId,
      isEpgLiveMiniPlayerEnabled,
      isHomePage,
      isLivePage,
      isPlayerLoaded,
      key: 'home-video-global',
      location,
      openSignIn,
      openSignUp,
      params,
      profileId,
      provider,
      renderAuthContainer: this.renderAuthContainer,
      setAccountCloseIgnoreRedirect: this.setAccountCloseIgnoreRedirect,
      setAuthorizationToken: this.setAuthorizationToken,
      setIsAuthenticated: this.setIsAuthenticated,
      setIsPlayerLoaded: this.setIsPlayerLoaded,
      setMVPDLogoutDataToAppState: this.setMVPDLogoutDataToAppState,
      setMVPDSignInTrigger: this.setMVPDSignInTrigger,
      setMVPDToAppState: this.setMVPDToAppState,
      setOverlay: this.setOverlay,
      setProvider: this.setProvider,
      triggerAuthCheck,
    };

    return <VideoPlayerGlobal {...props} />;
  }

  onSimplifiedSignUpClick = () => {
    this.setState({ useSimplified: true });
    addBodyClass(['noScroll']);
  };

  wrapLoaderOverlay = children => {
    const { renderLoader } = this.state;
    return (
      <div className={classNames(renderLoader && AppStyleModule.loaderWrap)}>
        <img
          className={AppStyleModule.loaderImg}
          src="/static/images/loader.png"
          alt="Loading..."
        />
        <div className={classNames(renderLoader && AppStyleModule.hiddenContent)}>{children}</div>
      </div>
    );
  };

  render() {
    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken,
      buythroughScenario,
      children,
      fetchMVPDProviders,
      isAuthenticated,
      location,
      mvpdProviders,
      params,
      preauthorizedResources,
      setPreauthorizedResources,
      topMVPDProviders,
    } = this.props;
    const {
      accountCloseIgnoreRedirect,
      accountExpired,
      adblock,
      apiBreakpoint,
      blackoutDefinitions,
      breakpoint,
      campaignOverrides,
      coordinates,
      isHeader,
      isHeaderPinned,
      isHomePage,
      isListPage,
      isLivePage,
      isNavScheduleRendered,
      isPageLoading,
      isPlayerLoaded,
      isVideoHero,
      isWatchPage,
      isSmartBannerEnabled,
      mvpdAuthOverlayProps,
      network,
      overlay,
      preauthRefreshComplete,
      provider,
      selectedNetwork,
      showForgotPasswordLanding,
      renderMvpdAuthOverlay,
      mvpdSignInTrigger,
      showSignIn,
      showSignUp,
      utagAccountSource,
      firstIdentifyCall,
      firstCollectionImpression,
      upcomingOverlayOpen: isUpcomingOverlayOpen,
      stickyBanner,
      useSimplified,
    } = this.state;
    const {
      facebook_loginOptionalText: fbOptionalLoginText,
      facebook_loginText: fbLoginText,
      facebook_signupOptionalText: fbSignUpOptionalText,
      facebook_signupText: fbSignupText,
    } = window.Language;
    const perks = helperGetPerks();
    const { overlay: initialAccountScreen } = params;
    const externalHelpers = this.getExternalHelpers();
    const blackoutConfig = getBlackoutConfig();
    const analyticsLoaded = !!_.get(window, 'analytics.init');
    const getChildrenWithProps = () =>
      React.Children.map(children, child =>
        React.cloneElement(child, {
          ...externalHelpers,
          account,
          accountExpired,
          adblock,
          analyticsLoaded,
          apiBreakpoint,
          authorizationToken,
          blackoutConfig,
          blackoutDefinitions,
          breakpoint,
          campaignOverrides,
          collectionImpressionCalled: this.collectionImpressionCalled,
          coordinates,
          disableScroll: this.disableScrollByClass,
          fetchMVPDProviders,
          firstCollectionImpression,
          firstIdentifyCall,
          isAuthenticated,
          isHeader,
          isHeaderPinned,
          isNavScheduleRendered,
          isPlayerLoaded,
          isUpcomingOverlayOpen,
          mvpdProviders,
          mvpdSignInTrigger,
          overlay,
          params,
          provider,
          setPreauthorizedResources,
          showAccount: this.showAccount,
          topMVPDProviders,
          upcomingOverlayOpen: this.upcomingOverlayOpen,
        }),
      );
    const { autoFocus, mainBackground } = breakpoints[breakpoint];
    const profileId = _.get(account, 'profileId');
    const { foxProfileState } = userAttributeEvents();
    const accountAnalytics = getAccountAnalyticsEvents({ foxProfileState, profileId });
    const anonymousProfileId = _.get(anonymousAccount, 'profileId');
    const accountEmail = _.get(account, 'email');
    const networks = [];
    const mvpd = _.get(provider, 'nameLowercase');
    const entitlements = _.isEmpty(preauthorizedResources)
      ? ''
      : preauthorizedResources.sort(sortEntitlements).join(',');
    const headerPadding = [style.defaultPadding];
    const privacyPolicyClickEvent = {
      'Privacy Policy': () => handleAnalytics({ event: Events.PRIVACY_POLICY_PAGE_VIEW }),
    };
    const homePath = helperGetHomeUrl();
    const currentPath = _.get(this.props, 'location.pathname');
    const isHome = homePath === currentPath;
    const isArticle = toBoolean(_.get(params, 'articleId', false));
    let background = isVideoHero && mainBackground ? null : mainBackground;
    const onSignupClick = () => {};
    const onLoginClick = () => {};

    if (isNavScheduleRendered) headerPadding.push(style.navPadding);
    if (!background && isVideoHero) background = style.blackBackground;
    _.each(network, name => networks.push({ name, logo: getNetworkLogoUrl(name, 50) }));
    const appStyle = classNames([
      style.app,
      getFontClassName(style),
      'ft-theme-provider',
      isStaticRender() && 'staticRender',
      AppStyleModule.appContainer,
      AppStyleModule.headerPadding,
      AppStyleModule.withNetworks,
    ]);
    const optimizelyProfileProps = {
      useMVPDLoginProfile: !isAuthenticated && optimizelyUseMVPDLoginProfile(),
      optimizelyLanguageStrings,
      toggleMvpdAuthOverlay: () => {
        const options = {
          onOverlayClose: () => {
            this.toggleMvpdAuthOverlay(false, {});
            this.closeAccount();
          },
        };
        this.toggleMvpdAuthOverlay(true, options, false);
      },
    };
    const showFooterUpsell = false && isHome && FooterUpsellEnabled;
    const isLivePageAndEpgV2Enabled = isLivePage && isEpgv2Enabled();
    const isSeriesDetailPage = !_.isEmpty(params.showId);

    if (isWatchPage) this.setDisableScroll({ disableScroll: false });

    const mainStyle = classNames([
      style.main,
      background,
      'ft-header-content',
      (isWatchPage || isArticle) && style.gradientBackground,
      isSeriesDetailPage && AppStyleModule.overflowHidden,
    ]);
    const appWrapperStyle = classNames([]);

    const rootId = isStaticRender() ? 'app-static' : 'app-root';

    const components = (
      <div
        ref={this.appRef}
        className={(isLivePageAndEpgV2Enabled && AppStyleModule.livePageOverflowWrap) || null}
        id="live-page-overflow"
      >
        <div className={appStyle} id={rootId}>
          <div className={classNames(headerPadding)} />
          {this.renderDefaultHelmetTags()}
          {getFontHelmetTag()}
          <WindowResizeListener DEBOUNCE_TIME={DEBOUNCE_TIME} onResize={this.onWindowResize} />
          <Segment
            anonymousAccount={anonymousAccount}
            account={account}
            anonymousId={anonymousId}
            entitlements={entitlements}
            firstIdentifyCall={firstIdentifyCall}
            firstSegmentIdentifyCalled={this.firstSegmentIdentifyCalled}
            loggedInAccountEmail={accountEmail}
            loggedInAccountProfileId={profileId}
            loggedInAnonymousProfileId={anonymousProfileId}
            mvpd={mvpd}
            preauthorizedResources={preauthorizedResources}
          />
          {renderMvpdAuthOverlay && this.renderAuthContainer(mvpdAuthOverlayProps)}
          <Account
            account={account}
            accountEmail={accountEmail}
            accountExpired={accountExpired}
            anonymousAccount={anonymousAccount}
            apiBreakpoint={apiBreakpoint}
            autoFocus={autoFocus}
            backgroundClass="withBackground"
            breakpoint={breakpoint}
            closeAccount={this.closeAccount}
            editAccountCb={data => {
              const { account: currentAccount, setUserAuthData } = this.props;
              const newAccount = { ...currentAccount, ...data };
              if (!data) return null;
              setAccountCookie(newAccount);
              return setUserAuthData({ account: newAccount });
            }}
            facebookLoginOptionalText={fbOptionalLoginText}
            facebookLoginText={fbLoginText}
            facebookSignupOptionalText={fbSignUpOptionalText}
            facebookSignupText={fbSignupText}
            isMobile={isMobileBreakpoint(breakpoint)}
            isTablet={isTabletBreakpoint(breakpoint)}
            initialScreen={initialAccountScreen}
            ignoreOnCloseRedirect={accountCloseIgnoreRedirect}
            key="account"
            language={window.Language}
            loader={<Loader buttonLoader />}
            mvpdCookieName={mvpdCookieName}
            network={networks}
            onSignupClick={onSignupClick}
            onLoginClick={onLoginClick}
            pageViewEvent={this.pageViewEvent}
            params={params}
            perks={perks}
            privacyPolicyClickEvent={privacyPolicyClickEvent}
            renderFavorites={renderFavorites}
            renderNetworkLink={clickEvent => (
              <NetworkLink
                preauthorizedResources={preauthorizedResources}
                clickEvent={clickEvent}
                disableLink
              />
            )}
            renderPerkImage={image =>
              renderImage({
                breakpoint,
                imageType: PERK_ICON_IMAGE,
                ...image,
              })
            }
            selectedNetwork={selectedNetwork}
            setAccountCloseIgnoreRedirect={this.setAccountCloseIgnoreRedirect}
            setLoading={this.setLoading}
            showAccount={this.showAccount()}
            showForgotPasswordLanding={showForgotPasswordLanding}
            showSignIn={showSignIn}
            showSignUp={showSignUp}
            signInSuccess={() => {
              this.checkDeepLinkFavorite();
              this.resetAnonymous();
            }}
            signupSuccess={this.onSignUpSuccess}
            utagAccountSource={utagAccountSource}
            {...accountAnalytics}
            {...externalHelpers}
            {...optimizelyProfileProps}
          />
          <Header
            account={account}
            accessToken={authorizationToken}
            apiBreakpoint={apiBreakpoint}
            breakpoint={breakpoint}
            buythroughScenario={buythroughScenario}
            campaignOverrides={campaignOverrides}
            coordinates={coordinates}
            isAuthenticated={isAuthenticated}
            isHeader={isHeader}
            isHeaderPinned={isHeaderPinned}
            isHomePage={isHomePage}
            isListPage={isListPage}
            isLivePage={isLivePage}
            isNavScheduleRendered={isNavScheduleRendered}
            isPlayerLoaded={isPlayerLoaded}
            isSeriesDetailPage={isSeriesDetailPage}
            isVideoPage={isWatchPage || isLivePage}
            isWatchPage={isWatchPage}
            isSmartBannerEnabled={isSmartBannerEnabled}
            key="header"
            location={location}
            mvpdProviders={mvpdProviders}
            onSimplifiedSignUpClick={this.onSimplifiedSignUpClick}
            overlay={overlay}
            params={params}
            preauthRefreshComplete={preauthRefreshComplete}
            provider={provider}
            setMVPDSignInTrigger={this.setMVPDSignInTrigger}
            setCoordinates={this.setCoordinates}
            setAuthorizationToken={this.setAuthorizationToken}
            setHeaderPin={this.setHeaderPin}
            setNavScheduleRendered={this.setNavScheduleRendered}
            setMVPDLogoutDataToAppState={this.setMVPDLogoutDataToAppState}
            setPreauthRefreshComplete={this.setPreauthRefreshComplete}
            setProvider={this.setProvider}
            setSmartBannerEnabled={this.setSmartBannerEnabled}
            showAppDownloadPrompt={appDownloadPromptEnabled()}
            firstCollectionImpression={firstCollectionImpression}
            collectionImpressionCalled={this.collectionImpressionCalled}
            upcomingOverlayOpen={this.upcomingOverlayOpen}
            useSimplified={useSimplified}
            {...externalHelpers}
          />
          <div className={appWrapperStyle}>
            {this.renderGlobalVideoPlayer()}
            <main role="main" className={mainStyle}>
              {getChildrenWithProps()}
            </main>
          </div>
          {!isPageLoading && showFooterUpsell && (
            <FooterUpsell
              accessToken={authorizationToken}
              breakpoint={breakpoint}
              isPageLoading={isPageLoading}
              {...externalHelpers}
            />
          )}
          <Footer
            showFooterUpsell={showFooterUpsell}
            accessToken={authorizationToken}
            breakpoint={breakpoint}
            apiBreakpoint={apiBreakpoint}
            mvpdProviders={mvpdProviders}
            isPageLoading={isPageLoading}
            {...externalHelpers}
          />
          <StickyBanner data={stickyBanner} />
          <BlackoutDefinitionFetcher onComponentUpdate={this.onBlackoutDefinitionFetcherUpdate} />
          <CanIAutoplay />
        </div>
      </div>
    );

    return wrapComponentsWithThemeProvider(components);
  }
}

App.defaultProps = {
  account: null,
  anonymousAccount: null,
  anonymousId: null,
  authorizationToken: null,
  buythroughScenario: null,
  children: null,
  deviceId: null,
  fetchMVPDProviders: noop,
  isAuthenticated: false,
  mvpd: null,
  mvpdLogoutData: null,
  mvpdProviders: null,
  params: {},
  preauthorizedResources: [],
  profile: null,
  recommendationId: null,
  routes: [],
  segmentDeviceId: null,
  seriesData: null,
  stickyBanner: null,
  topMVPDProviders: [],
  videoPanel: null,
};

App.propTypes = {
  account: PropTypes.shape({}),
  anonymousAccount: PropTypes.shape({}),
  anonymousId: PropTypes.string,
  authorizationToken: PropTypes.string,
  buythroughScenario: PropTypes.string,
  children: PropTypes.node,
  deviceId: PropTypes.string,
  fetchMVPDProviders: PropTypes.func,
  fetchPCS: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
  mvpd: PropTypes.shape({}),
  mvpdLogoutData: PropTypes.shape({}),
  mvpdProviders: PropTypes.arrayOf(PropTypes.shape({})),
  params: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  profile: PropTypes.shape({}),
  profileConfig: PropTypes.shape({}),
  recommendationId: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
  segmentDeviceId: PropTypes.string,
  seriesData: PropTypes.shape({}),
  setIsGoogleSignedInBrowser: PropTypes.func,
  setGoogleOneTap: PropTypes.func,
  setIsGoogleOneTapDisplayed: PropTypes.func,
  setPreauthorizedResources: PropTypes.func.isRequired,
  setUserAuthData: PropTypes.func.isRequired,
  setUserProfileConfig: PropTypes.func.isRequired,
  stickyBanner: PropTypes.shape({}),
  topMVPDProviders: PropTypes.arrayOf(PropTypes.shape({})),
  videoPanel: PropTypes.shape({}),
};

const mapStateToProps = state => {
  const {
    account,
    anonymousAccount,
    anonymousId,
    authorizationToken,
    buythroughScenario,
    deviceId,
    googleSignIn,
    isAuthenticated,
    mvpd,
    mvpdLogoutData,
    mvpdProviders,
    preauthorizedResources,
    profile,
    profileConfig,
    recommendationId,
    segmentDeviceId,
    topMVPDProviders,
  } = state.app;
  const stickyBanner = getStickBannerData(state);
  const seriesData = makeSelectSeriesDetailSeriesData(state);
  const videoPanel = makeSelectGlobalVideoPanelVideo(state);
  return {
    account,
    anonymousAccount,
    anonymousId,
    authorizationToken,
    buythroughScenario,
    deviceId,
    googleSignIn,
    isAuthenticated,
    mvpd,
    mvpdLogoutData,
    mvpdProviders,
    preauthorizedResources,
    profile,
    profileConfig,
    recommendationId,
    segmentDeviceId,
    seriesData,
    stickyBanner,
    topMVPDProviders,
    videoPanel,
  };
};

const mapDispatchToProps = {
  fetchMVPDProviders: fetchMVPDProvidersAction,
  fetchPCS,
  setGoogleOneTap,
  setIsGoogleSignIn,
  setIsGoogleOneTapDisplayed,
  setNewGoogleEmailAndToken,
  setIsGoogleSignedInBrowser,
  setPreauthorizedResources: setPreauthorizedResourcesAction,
  setRecommendationId: setRecommendationIdAction,
  setUserAuthData,
  setUserProfileConfig,
};
const WrappedApp = withErrorBoundary(App);
WrappedApp.fetchData = ({ store, accessToken }) => Footer.fetchData({ store, accessToken });

export default connect(mapStateToProps, mapDispatchToProps)(WrappedApp);
